module.exports = {
      id: "comm-technology-usage",
      viewBox: "0 0 366.545 49.888",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#comm-technology",
      toString: function () {
        return this.url;
      }
    }